// extracted by mini-css-extract-plugin
export default {"dropdownButton":"ChangePsPatientPractice_dropdownButton__hUMHa"};